import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import {
  CategoryFormDataType,
  ClassifierFormDataType,
} from '@atlas-frontend/sdk';

export const useCategoryRelationOptions = (isCombinedGroups: boolean) => {
  const name = useMemo(
    () =>
      isCombinedGroups
        ? (['categories', 'categoryGroups'] as const)
        : (['categories'] as const),
    [isCombinedGroups],
  );

  const categories = useWatch<ClassifierFormDataType>({
    name,
  }) as CategoryFormDataType[][];

  return useMemo(
    () =>
      categories.flat().map(({ code, name, categoryType }) => ({
        value: code,
        label: `${code} - ${name}`,
        type: categoryType,
      })),
    [categories],
  );
};
